import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Plugin } from "types/generated";

const PluginsTableCreatedAtCell = ({
  item: plugin,
  ...cellProps
}: TableSimpleCellProps<Plugin>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={plugin.createdAt} />
    </TableSimpleCell>
  );
};

export default PluginsTableCreatedAtCell;
